import React from 'react';
import { SectionReveal } from './ui/SectionReveal';
import { ArrowUpRight } from 'lucide-react';
export function CaseStudies() {
  const cases = [{
    company: 'Series B FinTech',
    size: '80 engineers',
    challenge: 'Struggling with slow release cycles and high change failure rate.',
    metric: '+34%',
    metricLabel: 'Deployment Frequency',
    result: 'Implemented DORA tracking and automated testing gates, reducing cycle time by 2.4x.'
  }, {
    company: 'PE-Backed SaaS',
    size: '150 engineers',
    challenge: 'Siloed teams and lack of visibility into engineering allocation.',
    metric: '40%',
    metricLabel: 'Increase in Feature Velocity',
    result: 'Restructured into cross-functional pods and aligned engineering KPIs with product goals.'
  }, {
    company: 'Series A HealthTech',
    size: '30 engineers',
    challenge: 'First-time managers struggling to scale the team and maintain quality.',
    metric: '0 to 1',
    metricLabel: 'Engineering Ladder',
    result: 'Built clear career progression frameworks and implemented structured 1:1s.'
  }];
  return <section id="work" className="py-24 md:py-32 bg-surface/30" data-id="element-76">
      <div className="container mx-auto px-6 md:px-12" data-id="element-77">
        <SectionReveal data-id="element-78">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16" data-id="element-79">
            <div className="max-w-2xl" data-id="element-80">
              <h2 className="font-serif text-4xl md:text-5xl mb-6" data-id="element-81">
                Selected Work
              </h2>
              <p className="text-lg text-secondary" data-id="element-82">
                Real results from partnering with engineering organizations to
                solve complex scaling challenges.
              </p>
            </div>
          </div>
        </SectionReveal>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-83">
          {cases.map((study, index) => <SectionReveal key={index} delay={index * 0.1} data-id="element-84">
              <div className="group h-full p-8 rounded-2xl bg-base border border-border hover:border-accent/50 transition-all duration-300 hover:-translate-y-1 cursor-pointer" data-id="element-85">
                <div className="flex justify-between items-start mb-8" data-id="element-86">
                  <div data-id="element-87">
                    <span className="inline-block py-1 px-3 rounded-full bg-surface text-xs font-medium text-secondary mb-3" data-id="element-88">
                      {study.company} • {study.size}
                    </span>
                  </div>
                  <ArrowUpRight className="w-5 h-5 text-muted group-hover:text-accent transition-colors" data-id="element-89" />
                </div>

                <div className="mb-8 pb-8 border-b border-border" data-id="element-90">
                  <p className="text-sm text-secondary leading-relaxed" data-id="element-91">
                    <span className="text-primary font-medium" data-id="element-92">Challenge:</span>{' '}
                    {study.challenge}
                  </p>
                </div>

                <div data-id="element-93">
                  <div className="font-serif text-5xl text-accent mb-2 tracking-tight" data-id="element-94">
                    {study.metric}
                  </div>
                  <p className="text-sm font-medium text-primary mb-3 uppercase tracking-wider" data-id="element-95">
                    {study.metricLabel}
                  </p>
                  <p className="text-sm text-secondary leading-relaxed" data-id="element-96">
                    {study.result}
                  </p>
                </div>
              </div>
            </SectionReveal>)}
        </div>
      </div>
    </section>;
}